import { createIcon } from "@chakra-ui/react";
export const FilterAltFilled = createIcon({
  displayName: "FilterAltFilled",
  viewBox: "0 -960 960 960",
  d: "M471.561-212.001q-8.252 0-13.906-5.554t-5.654-13.831v-218.538l-226.922-274.46q-5.538-7.385-1.591-15.5 3.948-8.115 12.898-8.115h487.228q8.95 0 12.898 8.115 3.947 8.115-1.591 15.5l-226.922 274.46v218.538q0 8.277-5.537 13.831t-13.789 5.554h-17.112z",
});
